import { BaseClient } from 'src/common-services/clients/base-client'
import { AMAuthTiles, AMPOIDensity } from 'src/common-services/types/alphamap'

export class TilesClient extends BaseClient {
  tilesPathPrefix = '/api/v2/tiles'
  tilesPathPostfix = '{z}/{x}/{y}.mvt'

  async getAuth(): Promise<AMAuthTiles> {
    const response = await this.call<AMAuthTiles>(`/v2/tiles/auth`, 'GET')
    return {
      ...response,
      host: response.host || window.location.origin,
    }
  }

  getLocationsPath(density: AMPOIDensity, categories: string, withMobilityData: number): string {
    return `${this.tilesPathPrefix}/locations/${density}/${categories}/${withMobilityData}/${this.tilesPathPostfix}`
  }

  getLocationsByBrandPath(brandId: string, locationId = 'none', date = 'none', scope = 'country'): string {
    return `${this.tilesPathPrefix}/locations-by-brand/${brandId}/${locationId}/${scope}/${date}/${this.tilesPathPostfix}`
  }

  getLocationsByCategoryPath(locationId = 'none', naics = 'none', date = 'none', scope = 'country'): string {
    return `${this.tilesPathPrefix}/locations-by-category/${locationId}/${naics}/${scope}/${date}/${this.tilesPathPostfix}`
  }

  getCensusBlockGroupsPath(): string {
    return `${this.tilesPathPrefix}/census-block-groups/${this.tilesPathPostfix}`
  }

  getZipCodesPath(): string {
    return `${this.tilesPathPrefix}/zip-codes/${this.tilesPathPostfix}`
  }
}
